import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { Flex, Paper, Radio, Stack, Title, Box } from "@mantine/core";
import { IGKRapport, IGKVisualiseringAvLuftstroemResultater } from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";
const VisualiseringAvLuftstroem: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKVisualiseringAvLuftstroemResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Visualisering av luftstrøm
        </Title>
        <div style={{ marginTop: 0, width: "50%" }}>
          <div>
            <McTextAreaNew
              label="Beskrivelse av luftstrøm:"
              value={data.inndata.beskrivelseAvLuftstroem}
              onChange={(e) =>
                onUpdateEditData(
                  "testResultater.visualiseringAvLuftstroem.inndata.beskrivelseAvLuftstroem",
                  e.target.value,
                )
              }
            />
          </div>
          <div>
            <Flex direction="column" mt="sm">
              <Radio
                checked={data.inndata.godkjent === true}
                onChange={() => onUpdateEditData("testResultater.visualiseringAvLuftstroem.inndata.godkjent", true)}
                label="Godkjent"
              />
              <Radio
                checked={data.inndata.godkjent === false}
                onChange={() => onUpdateEditData("testResultater.visualiseringAvLuftstroem.inndata.godkjent", false)}
                label="Ikke godkjent"
              />
            </Flex>
          </div>
        </div>
        <Box mt="lg">
          <ReportDocxImageContainer docxImageTag="visualiseringAvLuftstroem" title="Bilde av luftstrøm" />
          <div style={{ width: "50%" }}>
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.kommentar}
              onChange={(e) =>
                onUpdateEditData("testResultater.visualiseringAvLuftstroem.inndata.kommentar", e.target.value)
              }
            />
          </div>
        </Box>
      </Stack>
    </Paper>
  );
};
export default VisualiseringAvLuftstroem;
